import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CloseCircleIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1C5.93466 1 1 5.93466 1 12C1 18.0653 5.93466 23 12 23C18.0653 23 23 18.0653 23 12C23 5.93466 18.0653 1 12 1ZM15.9827 14.7865C16.0646 14.8643 16.1301 14.9577 16.1753 15.0612C16.2205 15.1647 16.2446 15.2762 16.246 15.3891C16.2475 15.502 16.2263 15.6141 16.1837 15.7187C16.1412 15.8234 16.0781 15.9184 15.9983 15.9983C15.9184 16.0781 15.8234 16.1412 15.7187 16.1837C15.6141 16.2263 15.502 16.2475 15.3891 16.246C15.2762 16.2446 15.1647 16.2205 15.0612 16.1753C14.9577 16.1301 14.8643 16.0646 14.7865 15.9827L12 13.1968L9.21351 15.9827C9.05353 16.1347 8.84051 16.2182 8.61987 16.2154C8.39923 16.2126 8.18841 16.1237 8.03238 15.9676C7.87635 15.8116 7.78744 15.6008 7.78462 15.3801C7.78179 15.1595 7.86527 14.9465 8.01726 14.7865L10.8032 12L8.01726 9.21351C7.86527 9.05353 7.78179 8.84051 7.78462 8.61987C7.78744 8.39923 7.87635 8.18841 8.03238 8.03238C8.18841 7.87635 8.39923 7.78744 8.61987 7.78462C8.84051 7.78179 9.05353 7.86527 9.21351 8.01726L12 10.8032L14.7865 8.01726C14.9465 7.86527 15.1595 7.78179 15.3801 7.78462C15.6008 7.78744 15.8116 7.87635 15.9676 8.03238C16.1237 8.18841 16.2126 8.39923 16.2154 8.61987C16.2182 8.84051 16.1347 9.05353 15.9827 9.21351L13.1968 12L15.9827 14.7865Z"
        fill={color || "#C40000"}
      />
    </svg>
  );
}
